export default __webpack_public_path__ + "static/media/icon_chevron_arrowhead_right.d88a221c.svg";